
















































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import SupervisiLaundryService from "@/services/SupervisiLaundryService";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import {
  composeDate,
  toDateString,
  toTimeString
} from "@/utils/asesmenIntensifDateTime";
import { appModule } from "@/store/modules/app";

interface ChecklistItem {
  key: string;
  label: string;
}

interface ChecklistSection {
  code: string;
  title: string;
  items: ChecklistItem[];
}

interface CeklistItem {
  kategori: string;
  item_key: string;
  item_label: string;
  urutan: number;
  hasil: "ya" | "tidak" | null;
  masalah: string;
  rekomendasi: string;
}

const JAM_CARRIER = toDateString(new Date()) || "2000-01-01";

@Component({ components: { VCDateTimePicker } })
export default class SupervisiLaundryFormDialog extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ default: null }) editData!: any;

  saving = false;
  loadingDetail = false;
  isLegacy = false;
  loadSeq = 0;

  form: any = {};
  items: CeklistItem[] = [];
  kategoriLabels: Record<string, string> = {};

  sectionI: ChecklistItem[] = [
    { key: "s1_pintu_berbeda", label: "Pintu penerimaan dan pendistribusian berbeda" },
    { key: "s1_lokasi_proses_berbeda", label: "Lokasi masing-masing proses berbeda (penerimaan, penghitungan dan penimbangan terpisah dengan linen bersih)" },
  ];

  sectionII: ChecklistItem[] = [
    { key: "s2_sarana_cuci_tangan", label: "Tersedia sarana cuci tangan lengkap" },
    { key: "s2_apd_lengkap", label: "Tersedia APD lengkap" },
    { key: "s2_tempat_penyimpanan_b3", label: "Ada tempat penyimpanan B3" },
    { key: "s2_temperature_ruang_bersih", label: "Temperature ruang bersih 22°C – 27°C" },
    { key: "s2_linen_tidak_berserakan", label: "Linen tidak berserakan di lantai" },
  ];

  sectionIII: ChecklistItem[] = [
    { key: "s3_one_day_service", label: "Pelayanan linen bersih one day servis" },
    { key: "s3_bukti_pemeriksaan_air_panas", label: "Ada bukti hasil pemeriksaan air panas" },
    { key: "s3_dokumen_pendistribusian", label: "Ada dokumen pendistribusian" },
    { key: "s3_petugas_apd_sesuai", label: "Petugas memakai APD yang sesuai" },
    { key: "s3_proses_sesuai_prosedur", label: "Proses pencucian sampai dengan pendistribusian berjalan sesuai prosedur" },
  ];

  created() {
    this.form = this.getEmptyForm();
  }

  get dialogVisible() {
    return this.value;
  }

  set dialogVisible(val: boolean) {
    this.$emit("input", val);
  }

  get isEdit() {
    return this.editData && this.editData.id;
  }

  get dialogTitle() {
    if (this.isLegacy) {
      return "Edit Supervisi Unit Laundry";
    }
    return (this.isEdit ? "Edit" : "Tambah") + " Ceklist Supervisi PPI — Unit Laundry";
  }

  get checklistRows() {
    const rows: any[] = [];
    let groupNo = 0;
    Object.keys(this.kategoriLabels).forEach(kategori => {
      const groupItems = this.items
        .filter(item => item.kategori === kategori)
        .sort((a, b) => a.urutan - b.urutan);
      if (!groupItems.length) return;
      groupNo += 1;
      groupItems.forEach((item, idx) => {
        rows.push({
          item,
          groupNo,
          kegiatan: this.kategoriLabels[kategori],
          isFirst: idx === 0,
          groupSize: groupItems.length,
          huruf: groupItems.length > 1 ? String.fromCharCode(97 + idx) + ". " : ""
        });
      });
    });
    return rows;
  }

  get sections(): ChecklistSection[] {
    return [
      { code: "s1", title: "I. SUPERVISI ALUR", items: this.sectionI },
      { code: "s2", title: "II. SUPERVISI FASILITAS DAN KEBERSIHAN", items: this.sectionII },
      { code: "s3", title: "III. SUPERVISI PROSES", items: this.sectionIII },
    ];
  }

  get allItems(): ChecklistItem[] {
    return this.sections.reduce(
      (acc: ChecklistItem[], s: ChecklistSection) => acc.concat(s.items),
      []
    );
  }

  setNilai(key: string, val: boolean) {
    this.$set(this.form, key, val);
  }

  get isFormValid() {
    const identitas =
      this.form.nomor_formulir &&
      this.form.tanggal_supervisi &&
      this.form.supervisor_nama;
    if (!this.isLegacy) {
      return identitas;
    }
    return identitas && this.form.waktu_mulai && this.form.waktu_selesai;
  }

  @Watch("value")
  async onDialogOpen(val: boolean) {
    if (!val) return;

    const seq = ++this.loadSeq;
    this.form = this.getEmptyForm();
    this.items = [];
    this.isLegacy = false;
    this.loadingDetail = true;
    try {
      const [templateRes, detailRes]: any[] = await Promise.all([
        SupervisiLaundryService.template(),
        this.editData && this.editData.id
          ? SupervisiLaundryService.find(this.editData.id)
          : Promise.resolve(null)
      ]);
      if (seq !== this.loadSeq) return;

      const template = templateRes.data.data;
      const detail: any = detailRes ? detailRes.data.data : null;

      this.kategoriLabels = template.kategori_labels || {};
      if (detail) {
        this.populateForm(detail);
        this.isLegacy = !(detail.items && detail.items.length);
        this.items = (detail.items || []).map((item: any) => this.toCeklistItem(item));
      } else {
        this.items = (template.items || []).map((item: any) => this.toCeklistItem(item));
      }
    } catch {
      if (seq === this.loadSeq) this.close();
    } finally {
      if (seq === this.loadSeq) this.loadingDetail = false;
    }
  }

  toCeklistItem(item: any): CeklistItem {
    return {
      kategori: item.kategori,
      item_key: item.item_key,
      item_label: item.item_label,
      urutan: Number(item.urutan),
      hasil: item.hasil || null,
      masalah: item.masalah || "",
      rekomendasi: item.rekomendasi || ""
    };
  }

  getEmptyForm() {
    const form: any = {
      nomor_formulir: "",
      tanggal_supervisi: "",
      waktu_mulai: "",
      waktu_selesai: "",
      supervisor_nama: "",
      supervisor_jabatan: "",
      temuan_utama: "",
      rencana_tindak_lanjut: "",
      kesimpulan: "",
      supervisor_ttd_nama: "",
      supervisor_ttd_tanggal: "",
      kepala_unit_ttd_nama: "",
      kepala_unit_ttd_tanggal: "",
    };

    for (const item of this.allItems) {
      form[item.key] = null;
      form[item.key + "_masalah"] = "";
      form[item.key + "_rekomendasi"] = "";
    }

    return form;
  }

  buildPayload() {
    if (!this.isLegacy) {
      return {
        nomor_formulir: this.form.nomor_formulir,
        tanggal_supervisi: this.form.tanggal_supervisi,
        supervisor_nama: this.form.supervisor_nama,
        kepala_unit_ttd_nama: this.form.kepala_unit_ttd_nama || null,
        kesimpulan: this.form.kesimpulan || null,
        items: this.items.map(item => ({
          item_key: item.item_key,
          hasil: item.hasil || null,
          masalah: item.masalah || null,
          rekomendasi: item.rekomendasi || null
        }))
      };
    }

    const payload: any = { ...this.form };
    delete payload.kesimpulan;
    for (const item of this.allItems) {
      if (payload[item.key] === null || payload[item.key] === undefined) {
        delete payload[item.key];
      }
    }
    return payload;
  }

  get tanggalSupervisiDate(): Date | null {
    return composeDate(this.form.tanggal_supervisi);
  }
  set tanggalSupervisiDate(val: Date | null) {
    this.$set(this.form, "tanggal_supervisi", toDateString(val) || "");
  }

  get waktuMulaiDate(): Date | null {
    if (!this.form.waktu_mulai) return null;
    return composeDate(JAM_CARRIER, String(this.form.waktu_mulai).slice(0, 5));
  }
  set waktuMulaiDate(val: Date | null) {
    this.$set(this.form, "waktu_mulai", toTimeString(val));
  }

  get waktuSelesaiDate(): Date | null {
    if (!this.form.waktu_selesai) return null;
    return composeDate(JAM_CARRIER, String(this.form.waktu_selesai).slice(0, 5));
  }
  set waktuSelesaiDate(val: Date | null) {
    this.$set(this.form, "waktu_selesai", toTimeString(val));
  }

  get supervisorTtdTanggalDate(): Date | null {
    return composeDate(this.form.supervisor_ttd_tanggal);
  }
  set supervisorTtdTanggalDate(val: Date | null) {
    this.$set(this.form, "supervisor_ttd_tanggal", toDateString(val) || "");
  }

  get kepalaUnitTtdTanggalDate(): Date | null {
    return composeDate(this.form.kepala_unit_ttd_tanggal);
  }
  set kepalaUnitTtdTanggalDate(val: Date | null) {
    this.$set(this.form, "kepala_unit_ttd_tanggal", toDateString(val) || "");
  }

  populateForm(data: any) {
    this.form = { ...this.getEmptyForm() };
    for (const key of Object.keys(this.form)) {
      if (data[key] !== undefined && data[key] !== null) {
        this.form[key] = data[key];
      }
    }
    if (this.form.tanggal_supervisi) {
      this.form.tanggal_supervisi = this.form.tanggal_supervisi.substring(0, 10);
    }
    if (this.form.waktu_mulai) {
      this.form.waktu_mulai = String(this.form.waktu_mulai).substring(0, 5);
    }
    if (this.form.waktu_selesai) {
      this.form.waktu_selesai = String(this.form.waktu_selesai).substring(0, 5);
    }
    if (this.form.supervisor_ttd_tanggal) {
      this.form.supervisor_ttd_tanggal = this.form.supervisor_ttd_tanggal.substring(0, 10);
    }
    if (this.form.kepala_unit_ttd_tanggal) {
      this.form.kepala_unit_ttd_tanggal = this.form.kepala_unit_ttd_tanggal.substring(0, 10);
    }
  }

  async save() {
    this.saving = true;
    try {
      if (this.isEdit) {
        await SupervisiLaundryService.update(this.editData.id, this.buildPayload());
        appModule.sendSuccessNotice("Supervisi berhasil diperbarui");
      } else {
        await SupervisiLaundryService.create(this.buildPayload());
        appModule.sendSuccessNotice("Supervisi berhasil ditambahkan");
      }
      this.$emit("saved");
      this.close();
    } finally {
      this.saving = false;
    }
  }

  close() {
    this.dialogVisible = false;
  }
}
